export function normalizeFormIds(formIds) {
    if (typeof formIds === 'string') {
        if (!formIds) {
            throw new Error('formId cannot be an empty string');
        }
        return [
            formIds
        ];
    }
    if (Array.isArray(formIds)) {
        if (formIds.length <= 0) {
            throw new Error('formIds cannot be an empty array');
        }
        if (formIds.some((id)=>typeof id !== 'string' || !id)) {
            throw new Error('formIds contain invalid id');
        }
        return formIds;
    }
    throw new Error('formIds argument is invalid');
}

//# sourceMappingURL=normalize-form-ids.js.map